// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "runtime~undefined" + "." + "b3b97a3387eb5c43" + ".js";
};